import React from "react";
import { IonSkeletonText } from "@ionic/react";

const skeletonItemList = [...Array(5).keys()];

export const CategoriesSkeleton = () => {
  return (
    <div className="flex flex-col gap-4 m-3">
      <IonSkeletonText animated className="w-52 h-6 rounded-sm" />

      {skeletonItemList.map((num) => (
        <div key={num} className="flex items-center gap-2">
          <IonSkeletonText animated className="w-12 h-12 rounded-full" />
          <IonSkeletonText animated className="w-full h-12 rounded-lg" />
        </div>
      ))}
    </div>
  );
};
